module.exports = __webpack_public_path__ + "static/media/Fallecimiento2.a0334773.svg";